import type { GQL_ID } from '@@partner:types:graphql'
import type { Stories } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_STORIES_FIELDS } from '@@partner:graphql/shortcuts'

export interface SingleStoryQuery {
  story: Stories
}
export interface SingleStoryQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_STORY = gql`
  query (
    $id: ID!
  ) {
    story: singleMarketingStory(id: $id) {
      ${SHORTCUT_STORIES_FIELDS}
    }
  }
`

export const useFetchSingleStory = (variables: SingleStoryQueryVariables) =>
  useQuery<SingleStoryQuery, SingleStoryQueryVariables>(
    GQL_QUERY_SINGLE_STORY,
    {
      variables,
      skip: !variables.id,
      fetchPolicy: 'cache-and-network'
    }
  )
